export default __webpack_public_path__ + "static/media/logo.32776a96.svg";